import { AiAgentFeatureDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface UseAiAgentFeatureResult {
  loading: boolean
  enabled: boolean
}

export const useAiAgentFeature = (): UseAiAgentFeatureResult => {
  const { data, loading } = useQuery(AiAgentFeatureDocument)

  const enabled = Boolean(
    data?.permissions.contextlessPolicyResolutions?.find(
      (resolution) => resolution.id === 'OpenAi_useOne'
    )?.can
  )

  return { loading, enabled }
}
